import { createEntitiesReducer } from '@mews-commander/legacy-entities/src/ducks/utils';
import { FLOOR_DELETED, FLOOR_ADDED, FLOOR_EDITED, REDUCERS_RESET } from '../actions/types';

export default createEntitiesReducer({
    ADD_SUCCESS: FLOOR_ADDED,
    UPDATE_SUCCESS: FLOOR_EDITED,
    DELETE_SUCCESS: FLOOR_DELETED,
    RESET_SUCCESS: REDUCERS_RESET,
});
